export const Tags = {
  qwFollowStatus: {
    1: '待跟进',
    2: '获得联系方式',
    3: '潜在意向',
    4: '待下单',
    5: '到店',
    6: '已成单',
    7: '自定义',
  },
  lgMethodTags: { 1: '线索清洗', 2: '线索抽检' },
  leadsTouchTag: {
     0: '待联系',
     4: '未接通-无效号码',
     1: '未接通-其他',
     2: '已接通-未回应',
     3: '已接通-已回应',
  },

  leadsIntentionTag: {
    1: '0',
    2: '0~20',
    3: '20~40',
    4: '40~60',
    5: '60~80',
    6: '80~100',
  },
  leadsIntentionSource: {
    1: '系统评分',
    2: '人工评分',
  },
  // leadsFollowTag: {
  //   999: '未分配',
  //   11: '已分配待跟进',
  //   1: '跟进中',
  //   2: '已转换-潜在客户',
  //   8: '已转换-高意向客户',
  //   3: '已转换-已成单',
  //   4: '无效-重复',
  //   5: '无效-非本人',
  //   6: '无效-未接通',
  //   7: '无效-无意向',
  //   9: '无效-定向外',
  //   10: '无效-其他',
  // },
  leadsStatus2: {
    1: '未分配',
    2: '已分配待跟进',
    3: '跟进中',
    4: '已转换-潜在客户',
    5: '已转换-高意向客户',
    6: '已转换-已成单',
    7: '无效-重复',
    8: '无效-非本人',
    9: '无效-未接通',
    10: '无效-无意向',
    11: '无效-定向外',
    12: '无效-其他',
  },

  leadsTagRelation: {
    // filter_industryCode1中行业的账户，下拉框中不展示此选项
    // 1: {desc:"电话异常", filter_industryCode1:[]},
    2: { desc: '电话重复', filter_industryCode1: [] },
    // 3: {desc:"分享注册", filter_industryCode1:[]},
    4: { desc: '疑似空号', filter_industryCode1: [] },
    // 6: { desc: '可疑数据', filter_industryCode1: [21474836482] },
    // 7: {desc:"预览数据, filter_industryCode1:[]}",
    9: { desc: '合约', filter_industryCode1: [] },
    11: { desc: '重复注册', filter_industryCode1: [] },
    // 无效赔付 满足返款 漏了两个貌似
    18: { desc: '机器人接待', filter_industryCode1: [] },
  },

  leadsCallCleaningTag: {
    1: '机器人-待联系',
    2: '机器人-高意向',
    3: '机器人-低意向',
    4: '机器人-无意向',
    5: '无效号码',
    6: '机器人-未接通',
    7: "机器人-无效号码",
    8: "未接通",
    9: "关机",
    10: "正常号码"
  },
  leadsCallCleaningTagEdit: {
    // 1: '机器人-待联系',
    2: '机器人-高意向',
    3: '机器人-低意向',
    4: '机器人-无意向',
    5: '无效号码',
    6: '机器人-未接通',
    7: "机器人-无效号码",
    8: "未接通",
    9: "关机",
    10: "正常号码"
  },
  leadsSourceTag: {
    // 1: "广告投放",
    2: '其他',
    3: '外部导入',
    4: '广告创意',
    5: '蹊径落地页',
    // 6: "枫页电商落地页",
    7: '一叶智能',
    8: '微信原生推广页',
    9: '讯达小程序',
    10: '云雀',
    11: '樱桃',
    12: '草莓卷',
    13: '栗子通',
    14: '知了',
    15: '果石',
    16: '盘子',
    17: '群友',
    18: '海螺云',
    19: '互动落地页',
    20: '智赢',
    21: '教培通',
    22: '优居',
    23: '亦芯',
    24: '艾推',
    25: '飞鱼',
    26: 'CMS落地页',
  },

  actionSubTypeTag: {
    0: '表单预约',
    1: '在线咨询',
    2: '普通电话',
    // 3: '网页回呼',
    4: '智能电话',
    5: '发券',
    6: '智能咨询',
    7: '抽奖',
    10: '一键授权',
    11: '加企业微信客服',
    12: '公众号内注册',
  },

  reservationTypeTag: {
    1: '表单提交',
    2: '一键授权',
    3: '留资咨询', // 离线留言，对广告主展示为留资咨询
    4: '留资咨询', // 在线咨询，对广告主展示为留资咨询
    5: '电话咨询',
  },

  leadsSubTypeTag: {
    // 表单预约的子类型
    10001: {
      desc: '提交表单',
      actionSubType: 0,
    },
    10002: {
      desc: '一键授权',
      actionSubType: 0,
    },
    10003: {
      desc: '留资咨询', // 离线留言，对广告主展示为留资咨询
      actionSubType: 0,
    },
    10004: {
      desc: '留资咨询', // 在线咨询，对广告主展示为留资咨询
      actionSubType: 0,
      hideInSelect: true,
    },
    10005: {
      desc: '电话咨询',
      actionSubType: 0,
    },

    // 一键授权的子类型
    11001: {
      desc: '提交表单',
      actionSubType: 10,
    },
    11002: {
      desc: '开口咨询',
      actionSubType: 10,
    },
    11003: {
      desc: '点击表单',
      actionSubType: 10,
    },
    11004: {
      desc: '点击咨询',
      actionSubType: 10,
    },
    11005: {
      desc: '点击拨打',
      actionSubType: 10,
    },
  },
};
